// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill';       //IE9
// if (Number.parseInt === undefined) Number.parseInt = window.parseInt;         //IE9
// if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat;   //IE9
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import QRCode from 'qrcode';    // 引入QRcode生成二维码
import '@/language/lang'
import md5 from 'js-md5';       // 引入md5加密
// import api from "@/api/homepage.js";
// import { Message, MessageBox } from 'element-ui'


Vue.use(QRCode);
Vue.use(ElementUI);
Vue.prototype.QRCode=QRCode;
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js